/**
 * @file ContactPage.js
 * @description Manages the Contact page and interactions.
 * (REFACTORED: Instant Actions Only)
 */

export class ContactPage {
    constructor(services) {
        this.contentManager = services.content;
        this.eventBus = services.eventBus; // Removed StateManager (No longer needed)
        this.dom = {
            content: document.querySelector('#contact .contact-links-container'),
        };
    }

    init() {
        this.render();
        this.addListeners();
    }

    render() {
        // ... (Render logic remains exactly the same) ...
        if (!this.dom.content) return;
        
        const contact = this.contentManager.getContact();
        const profile = this.contentManager.getProfile();
        
        // (Insert same icons and HTML generation as previous version)
        // ...
        // Re-pasting just the render logic for context:
        const iconMail = `<svg class="contact-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>`;
        const iconGithub = `<svg class="contact-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.477 2 2 6.477 2 12c0 4.418 2.865 8.166 6.839 9.488.5.09.682-.218.682-.483 0-.237-.009-.868-.013-1.703-2.782.602-3.369-1.34-3.369-1.34-.455-1.158-1.11-1.468-1.11-1.468-.908-.62.069-.608.069-.608 1.004.07 1.532 1.03 1.532 1.03.89 1.524 2.338 1.084 2.91.83.092-.645.348-1.084.635-1.334-2.22-.253-4.555-1.11-4.555-4.943 0-1.09.39-1.984 1.03-2.682-.103-.253-.447-1.27.098-2.646 0 0 .84-.27 2.75 1.026.798-.222 1.648-.334 2.498-.334.85 0 1.7.112 2.498.334 1.91-1.296 2.748-1.026 2.748-1.026.546 1.376.202 2.393.1 2.646.64.698 1.028 1.592 1.028 2.682 0 3.842-2.337 4.687-4.565 4.935.358.308.678.92.678 1.852 0 1.334-.012 2.41-.012 2.736 0 .267.18.577.688.48C19.138 20.163 22 16.417 22 12c0-5.523-4.477-10-10-10z"/></svg>`;
        const iconLinkedin = `<svg class="contact-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2zM8.5 18H6V9h2.5v9zM7.25 7.75A1.25 1.25 0 116 6.5a1.25 1.25 0 011.25 1.25zM18 18h-2.5v-4.5c0-1.06-.02-2.42-1.5-2.42-1.5 0-1.73 1.17-1.73 2.34V18H9.5V9h2.4v1.1h.03c.34-.64 1.18-1.3 2.36-1.3 2.53 0 3 1.66 3 3.82V18z"/></svg>`;

        // Inside ContactPage.js render()
        this.dom.content.innerHTML = `
            <h2 class="page-title">Contact</h2> 
            <a href="${profile.resume_url}" class="cta-button-primary" target="_blank" rel="noopener noreferrer" style="margin-bottom: 2rem;">
                Download Resume (PDF)
            </a>
            <div class="contact-links-grid">
                ${contact.email ? `<a href="mailto:${contact.email}" class="contact-link-button" data-type="mail">${iconMail}<span>Email Me</span></a>` : ''}
                ${contact.github ? `<a href="${contact.github}" class="contact-link-button" data-type="github" target="_blank" rel="noopener noreferrer">${iconGithub}<span>GitHub</span></a>` : ''}
                ${contact.linkedin ? `<a href="${contact.linkedin}" class="contact-link-button" data-type="linkedin" target="_blank" rel="noopener noreferrer">${iconLinkedin}<span>LinkedIn</span></a>` : ''}
            </div>
        `;
    }

    addListeners() {
        if (!this.dom.content) return;

        this.dom.content.querySelectorAll('.contact-link-button').forEach(link => {
            link.addEventListener('click', (e) => {
                const linkType = e.currentTarget.dataset.type;
                const url = e.currentTarget.href;

                // Simple Logic: Mail opens modal, everything else is standard link behavior
                if (linkType === 'mail') {
                    e.preventDefault(); 
                    console.log('[ContactLink] Opening mail modal');
                    this.eventBus.emit('modal:open:mail', { mailtoUrl: url });
                } 
                // No else needed. Default behavior (target="_blank") works for GitHub/LinkedIn
            });
        });
    }
}